import * as actions from "./PropertyActionType"

export const propertyPreview = (payload?: any): actions.PropertyRequest => {
  return {
    type: actions.PROPERTY_PREVIEW
  }
}
export const propertyUpdate = (payload: any): actions.PropertyUpdate => {
  return {
    type: actions.PROPERTY_UPDATE,
    payload
  }
}
export const propertyProcessSuccess = (payload: any): actions.PropertyProcessSuccess => {
  return {
    type: actions.PROPERTY_PROCESS_SUCCESS,
    payload
  }
}

export const propertyDataSourceSuccess = (value: any): actions.PropertyDataSourceSuccess => {
  return {
    type: actions.PROPERTY_DATASOURCE_SUCCESS,
    payload: value
  }
}
export const propertyProcessReset = () => {
  return {
    type: actions.PROPERTY_PROCESS_RESET
  }
}